import React from 'react';

interface CenteredInfoProps {
  children: React.ReactNode;
  variant?: 'default' | 'small';
  className?: string;
}

const CenteredInfo: React.FC<CenteredInfoProps> = ({
  children,
  variant = 'default',
  className = ''
}) => {
  const baseClasses = 'text-center';
  const variantClasses = variant === 'small' 
    ? 'text-xs text-gray-500' 
    : 'text-sm text-gray-600';
  
  return (
    <div className={`${baseClasses} ${className}`}>
      <p className={variantClasses}>
        {children}
      </p>
    </div>
  );
};

export default CenteredInfo;
